import React, { useEffect, useState } from 'react'
import { FoundationsInput } from '../../GenericComponents/input'
import { FoundationsButton } from '../../GenericComponents/button'
import { FoundationsSwitch } from '../../GenericComponents/switch'
import { FoundationsCheckBox } from '../../GenericComponents/checkbox'
import { FoundationsForm } from '../../GenericComponents/form'
import { FormValidation } from '../../FormValidationsRules'
import { useForm } from 'react-hook-form'
import {
    useSaveGeneralSettingsMutation,
    useSaveNotificationSettingsMutation,
    useSavePasswordSettingsMutation,
    useGetUsersListMutation,
    useProxyUserMutation
} from '../../Redux/UserSettings/userSettingsSlice'
import { FoundationsEnums } from '../../enum'
import Dialog from '../../GenericComponents/dialog'
import { passwordValidate } from '../../Utils'
import { Skeleton } from '../../GenericComponents/Skeleton'
import { checkType1OrHasPrivilege, redirectHome,encryptData, onEnter } from '../../GlobalMethods'
import { getAppSettings,getCurrentUserData, RootState } from '../../Redux/store'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { useDispatch, useSelector } from "react-redux";
import { setAppRedirectURL, setAppWorkflowState } from "../../Redux/store";
import { appWorkflowStates } from '../../Types/appWorkflowStates';
import { useTitleContext } from "../../Hooks/useTitleContext";
import { User as UserAccount } from '../../Redux/Admin_Tasks/userAccountSlice';

declare let window: any
const UnicornApp = window.unicornInstance as any

interface User {
    DisplayText: string;
    KeyValue: string;
    Description: string;
}
export interface PasswordData {
    oldPassword: string
    newPassword: string
    ReenterPassword: string
    ForceUserToChangePassword: boolean
}
export interface NotificationsData {
    emailSummaryReport: boolean
    emailNewNotes: boolean
    emailNewDictValues: boolean
    emailListenerActivity: boolean
}

const AccountSettings: React.FC = () => {

    const { setTitle } = useTitleContext();
    setTitle("Settings");

    const [isGeneralFormVisible, setGeneralFormVisible] = useState(false)
    const [isPasswordFormVisible, setPasswordFormVisible] = useState(false)
    const [isNotificationFormVisible, setNotificationFormVisible] = useState(false)
    const [isAttributesFormVisible, setAttributesFormVisible] = useState(false)
    const [isProxyModeAllowed, setisProxyModeAllowed] = useState(false)
    const [isDeveloperModeAllowed, setisDeveloperModeAllowed] = useState(false)
    const [proxyDialog, setproxyDialog] = useState(false)
    const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
    const [userList, setUserList] = useState<User[]>([]);
    const [findClicked, setfindClicked] = useState(false)
    const [Error, setError] = useState('')
    const [errorHighlight, setErrorHighlight] = useState(false);
    const [oldPasswordError, setOldPasswordError] = useState<string>(''); // To store old password error message as it need API call to validate.
    const [newPasswordError, setNewPasswordError] = useState<string>('');
    const currentUserData = useSelector(
        (state: RootState) => getCurrentUserData(state)
    )
    const appSettings: any = useSelector(
        (state: RootState) => { return getAppSettings(state)}
    )
    const {
        register: registerGeneral,
        handleSubmit: handleSubmitGeneral,
        formState: { errors: generalErrors },
    } = useForm<any>()
    

    const {
        register: registerPassword,
        handleSubmit: handleSubmitPassword,
        reset,
        formState: { errors: passwordErrors },
    } = useForm<any>();
    const [
        SaveGeneralSettings,
        { isLoading: generalLoading },
    ] = useSaveGeneralSettingsMutation()
    const [
        SavePasswordSettings,
        { isLoading: passwordLoading },
    ] = useSavePasswordSettingsMutation()
    const [
        SaveNotificationSettings,
        { isLoading: notificationLoading },
    ] = useSaveNotificationSettingsMutation()
    const [
        GetUsersList,
        { isLoading: getUserLoading },
    ] = useGetUsersListMutation()
    const [
        ProxyUser,
        { isLoading: proxyingUserLoading },
    ] = useProxyUserMutation()

    const [UserAttributes, setUserAttributes] = useState<any>()

    const [GeneralData, setGeneralData] = useState<Pick<UserAccount,
        'FirstName' | 'LastName' | 'OrganizationName' | 'NationalProviderID' | 'DeveloperMode'>>
        ({
            FirstName: '',
            LastName: '',
            OrganizationName: '',
            NationalProviderID: '',
            DeveloperMode: false,
        });

    const [PasswordData, setPasswordData] = useState<PasswordData>({
        oldPassword: '',
        newPassword: '',
        ReenterPassword: '',
        ForceUserToChangePassword: false,
    })

    const [NotificationData, setNotificationData] = useState<NotificationsData>({
        emailSummaryReport: false,
        emailNewNotes: false,
        emailNewDictValues: false,
        emailListenerActivity: false,
    })
    const [searchValue, setSearchValue] = useState('');

    const dispatch = useDispatch()

    function showUsersDialog() {
        setproxyDialog(!proxyDialog)
    }

    const findUser = () => {
        setSelectedUserId(null);
        if (getUserLoading) return;

        const reqUsers = { searchstring: searchValue };
        GetUsersList(reqUsers)
            .unwrap()
            .then(response => {
                if (response) {
                    const formattedUsers = response.map((user: any) => ({
                        DisplayText: `${user.firstName} ${user.lastName} (<i>${user.email}</i>)`,
                        KeyValue: user.id,
                        Description: user.role,
                    }));
                    setUserList(formattedUsers);
                } else {
                    setUserList([]);
                }
                setfindClicked(!findClicked)
            })
            .catch(error => {
                setError(error)
                setUserList([]);
            });
    };

    const handleKeydown = (e: React.KeyboardEvent<HTMLInputElement>) => {
       onEnter(e, findUser)
    }

    const handleProxyClick = () => {
        if (Number(selectedUserId) == 0) {
            setError('Please select a user and try again.')
            setErrorHighlight(true);
        
        // Reset the highlight after a short delay 
        setTimeout(() => {
            setErrorHighlight(false);
        }, 1000);
        } else {
            const proxyUser = {
                userId: Number(selectedUserId)
            }
            ProxyUser(proxyUser).unwrap().then(res =>{
                if (res.data !== null) {   
                    dispatch(setAppRedirectURL(redirectHome(currentUserData)))
                    dispatch(setAppWorkflowState(appWorkflowStates.FORCE_REDIRECT))  
                }
                else {
                    setError("Sorry, this user cannot be proxied right now. Please try again later.");
                }
            })
        }

    }

    const handleSelectUser = (userId: string) => {
        setSelectedUserId(userId);
    };
    useEffect(() => {
        if (currentUserData && currentUserData.AccountInfo) {
            const accountInfo = currentUserData.AccountInfo
            if(currentUserData.ForceUserToChangePassword===true){
                setPasswordFormVisible(true);
            }
            setGeneralData((prevData) => ({
                ...prevData,
                FirstName: accountInfo.firstName || '',
                LastName: accountInfo.lastName || '',
                OrganizationName: accountInfo.OrganizationName || '',
                NationalProviderID: accountInfo.NationalProviderID || '',
                DeveloperMode: currentUserData.DeveloperMode || false,
            }))
            setNotificationData((prevData) => ({
                ...prevData,
                emailSummaryReport: accountInfo.emailSummaryReport,
                emailNewNotes: accountInfo.emailNewNotes,
                emailNewDictValues: accountInfo.emailNewDictValues,
                emailListenerActivity: accountInfo.emailListenerActivity,
            }))
            setUserAttributes(currentUserData.UserAttributes)
            setisProxyModeAllowed(
                (!currentUserData.proxyInfo || !currentUserData.proxyInfo.isProxyMode) &&
                checkType1OrHasPrivilege(currentUserData,'AllowProxyUser')
            )
            setisDeveloperModeAllowed(currentUserData.privileges.includes('DeveloperMode'))
        }
    }, [currentUserData])

    useEffect(() => {
        if (!proxyDialog) {
            setUserList([]);
            setSearchValue('');
            setError('');
            setfindClicked(false);
        }
    }, [proxyDialog])
    

    const resetPasswordForm = () => {
    setPasswordData({
        oldPassword: '',
        newPassword: '',
        ReenterPassword: '',
        ForceUserToChangePassword: false
    });
    reset();
    setOldPasswordError(''); //clear old password error
    setNewPasswordError('');
    setPasswordFormVisible(false);
    };

    const resetNotificationForm = () => {
    if (currentUserData?.AccountInfo) {
        setNotificationData({
            emailSummaryReport: currentUserData.AccountInfo.emailSummaryReport,
            emailNewNotes: currentUserData.AccountInfo.emailNewNotes,
            emailNewDictValues: currentUserData.AccountInfo.emailNewDictValues,
            emailListenerActivity: currentUserData.AccountInfo.emailListenerActivity
        });
    }
    setNotificationFormVisible(false);
    };

    function showGeneralWrapper() {
        setGeneralFormVisible(!isGeneralFormVisible)
    }
    function showPasswordWrapper() {
    if (isPasswordFormVisible) {
        resetPasswordForm();
    } else {
        setPasswordFormVisible(true);
    }
    }

    function showNotificationWrapper() {
    if (isNotificationFormVisible) {
        resetNotificationForm();
    } else {
        setNotificationFormVisible(true);
    }
    }

    function showAttributesWrapper() {
        setAttributesFormVisible(!isAttributesFormVisible)
    }

    const handleGeneralInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target
        setGeneralData((prevData) => ({
            ...prevData,
            [name]: value,
        }))
    }

    const handleDeveloperToggle = (event: any) => {
        setGeneralData((prevData) => ({
            ...prevData,
            DeveloperMode: event.target.checked,
        }))
    }

    const passwordsMatch = (val: string) => {
        if (PasswordData.newPassword != val) {
            return 'Your password and confirm password do not match.'
        } else {
            return true
        }
    }

    const handlePasswordInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target
        setPasswordData((prevData) => ({
            ...prevData,
            [name]: value,
        }))
    }

    const handleNotificationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.target
        setNotificationData((prevData) => ({
            ...prevData,
            [name]: checked,
        }))
    }

    const handlePasswordSettings = () => {
        if (passwordLoading) {
            return
        }
        setOldPasswordError('');
        setNewPasswordError('');
        const encryptedPasswordData = {                                    //Prevent to insert encrepted string as *,
        oldPassword: encryptData(PasswordData.oldPassword.trim(), appSettings.PublicEncryptionKey),
        newPassword: encryptData(PasswordData.newPassword.trim(), appSettings.PublicEncryptionKey),
        ReenterPassword: encryptData(PasswordData.ReenterPassword.trim(), appSettings.PublicEncryptionKey),
        ForceUserToChangePassword: PasswordData.ForceUserToChangePassword
    };
        SavePasswordSettings(encryptedPasswordData)
            .unwrap()
            .then((response) => {
                if (response != null) {
                    var resultData = response.data
                    if (resultData != null && resultData.MessageResults.length > 0) {
                        resultData.MessageResults.forEach(
                            (msg: { HelpMessage: FoundationsEnums.Status; Message: any }) => {
                                if (msg.HelpMessage === FoundationsEnums.Status.Success) {
                                    FoundationsGenericToaster('success', msg.Message)
                                    resetPasswordForm();
                                    UnicornApp.internalEventChannel.trigger("clearUserAlert", "You are required to change the password to be able to access Foundations.");
                                } else {
                                    if (msg.Message.toLowerCase().includes('same as old')) {
                                        setNewPasswordError(msg.Message);
                                    } else {
                                    setOldPasswordError(msg.Message);
                                    }
                                
                            }
                            }
                        )
                    } else {
                        FoundationsGenericToaster('error', 'Sorry, changing password failed.')
                    }
                }
            })
    }

    const handleGeneralSettings = () => {
        if (generalLoading) {
            return
        }
        const sanitizedData = {
            ...GeneralData,
            firstName: GeneralData.FirstName.replace(/\s+/g, ' ').trim(),
            lastName: GeneralData.LastName.replace(/\s+/g, ' ').trim(),
            OrganizationName: GeneralData.NationalProviderID || '',
            NationalProviderID:GeneralData.NationalProviderID.replace(/\s+/g, ' ').trim(),
            DeveloperMode: GeneralData.DeveloperMode,
        }
        SaveGeneralSettings(sanitizedData)
            .unwrap()
            .then((response) => {
                if (response != null) {
                    var resultData = response.data
                    if (resultData != null && response.statusCode == 204) {
                        FoundationsGenericToaster('success', 'General settings updated successfully.')
                        setGeneralFormVisible(!isGeneralFormVisible) 
                    } else {
                        FoundationsGenericToaster(
                            'error',
                            'Sorry, changes to general settings failed. Please try again.'
                        )
                    }
                }
            })
    }

    const handleNotificationSettings = () => {
        if (notificationLoading) {
            return
        }
        SaveNotificationSettings(NotificationData)
            .unwrap()
            .then((response) => {
                if (response != null) {
                    var resultData = response.data
                    if (resultData != null && response.statusCode == 204) {
                        FoundationsGenericToaster('success', 'Notification settings updated successfully.')
                        setNotificationFormVisible(!isNotificationFormVisible) 
                    } else {
                        FoundationsGenericToaster(
                            'error',
                            'Sorry, changes to notification settings failed. Please try again.'
                        )
                    }
                }
            })
    }

    return (
        <>
            <div className="row">
                <div className="col">
                    <Skeleton loading={generalLoading} className="userSetting-header">
                        <div className="header">Account Settings</div>
                    </Skeleton>
                </div>
            </div>
            <div className="padding-top-large"></div>

            <Skeleton loading={generalLoading} height='350px' width='50%' >
            <div className="row">
                <div className="col-6">
                    <h3>General</h3>
                </div>
                <div className="col-6 text-right change">
                    <a
                        id="general_link"
                        className="click_toggle_form_visibility"
                        style={{ cursor: 'pointer' }}
                        onClick={showGeneralWrapper}
                    >
                        {isGeneralFormVisible ? 'Hide' : 'Change'}
                    </a>
                </div>
                <div className="col-12">
                    <hr className="m-t" />
                    <div id="general_desc" className="section-desc text-muted m-t show">
                        Change name, national provider identification, etc.
                    </div>
                </div>
            </div>
            <div className="padding-top-large"></div>

            {isGeneralFormVisible && (
                <div id="general_wrapper">
                    <div id="general_form">
                        <FoundationsForm
                            id="general_form_el"
                            submitFunction={handleSubmitGeneral(handleGeneralSettings)}
                        >
                            <div className="row">
                                <div className="col-sm-12">
                                    <FoundationsInput
                                        classes="form-group row"
                                        id="text_box_first_name_el"
                                        type="text"
                                        name="firstName"
                                        value={GeneralData.FirstName || ''}
                                        maxLength={50}
                                        inputClasses=""
                                        labelText="First Name:"
                                        errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                        labelClasses="col-sm-2 col-form-label"
                                        containerClasses="col-sm-4"
                                        onInput={handleGeneralInputChange}
                                        registerFunction={registerGeneral}
                                        registerRules={FormValidation.Settings.firstName}
                                        error={generalErrors.firstName?.message}
                                        registerName="FirstName"
                                    />
                                    <div style={{ height: '17px' }}>
                                        <label
                                            htmlFor="FirstName"
                                            className="error field-validation-error"
                                        ></label>
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <FoundationsInput
                                        classes="form-group row"
                                        id="text_box_last_name_el"
                                        type="text"
                                        name="lastName"
                                        value={GeneralData.LastName}
                                        maxLength={50}
                                        inputClasses=""
                                        labelText="Last Name:"
                                        errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                        labelClasses="col-sm-2 col-form-label"
                                        containerClasses="col-sm-4"
                                        onInput={handleGeneralInputChange}
                                        registerFunction={registerGeneral}
                                        registerRules={FormValidation.Settings.lastName}
                                        error={generalErrors.lastName?.message}
                                        registerName="LastName"
                                    />
                                    <div style={{ height: '17px' }}>
                                        <label
                                            htmlFor="LastName"
                                            className="error field-validation-error"
                                        ></label>
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <FoundationsInput
                                        classes="form-group row"
                                        id="text_box_npi_el"
                                        type="text"
                                        name="NationalProviderID"
                                        value={GeneralData.NationalProviderID}
                                        inputClasses=""
                                        maxLength={30}
                                        labelText="National Provider ID:"
                                        errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                        labelClasses="col-sm-2 col-form-label"
                                        toolTipText="Your National Provider Identifier (NPI)."
                                        data-tool_tip_img_id="help_NPI"
                                        containerClasses="col-sm-4"
                                        onInput={handleGeneralInputChange}
                                        registerFunction={registerGeneral}
                                        registerRules={FormValidation.Settings.NationalProviderID}
                                        error={generalErrors.NationalProviderID?.message}
                                        registerName="NationalProviderID"
                                    />
                                    <div style={{ height: '17px' }}>
                                        <label
                                            htmlFor="NationalProviderID"
                                            className="error field-validation-error"
                                        ></label>
                                    </div>
                                </div>

                                {isDeveloperModeAllowed && (
                                    <div className="col-sm-12">
                                        <div className="d-flex form-group">
                                            <div
                                                className="col-sm-2 col-form-label"
                                                style={{ marginLeft: '-15px' }}
                                            >
                                                Developer Mode:
                                            </div>
                                            <div
                                                className="col-sm-push-6"
                                                style={{ marginLeft: '20px' }}
                                            >
                                                <FoundationsSwitch
                                                    id="developer_mode_toggle_el"
                                                    name="DeveloperMode"
                                                    isChecked={GeneralData.DeveloperMode || false}
                                                    onChange={handleDeveloperToggle}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="row">
                                <div className="col-12 text-left d-flex justify-content-center">
                                    <FoundationsButton
                                        type="submit"
                                        classes="p-l-0"
                                        id="buttonGeneralSaveChanges"
                                        buttonClasses="app-button"
                                        isLoading={generalLoading}
                                        disabled={generalLoading}
                                        customStyle={{ marginLeft: '175px' }}
                                    >
                                        Save Changes
                                    </FoundationsButton>
                                    <FoundationsButton
                                        classes="col-4"
                                        id="buttonGeneralCancelChanges"
                                        buttonClasses="app-button negative"
                                        disabled={false}
                                        isLoading={generalLoading}
                                        onClick={() => setGeneralFormVisible(!isGeneralFormVisible)}
                                    >
                                        Cancel
                                    </FoundationsButton>
                                </div>
                            </div>
                        </FoundationsForm>
                    </div>
                </div>
            )}

            <div className="row">
                <div className="col-6">
                    <h3>Password</h3>
                </div>
                <div className="col-6 text-right negative-margin-y">
                    <a
                        id="password_link"
                        className="click_toggle_form_visibility"
                        style={{ cursor: 'pointer' }}
                        onClick={showPasswordWrapper}
                    >
                        {isPasswordFormVisible ? 'Hide' : 'Change'}
                    </a>
                </div>

                <div className="col-12">
                    <hr className="m-t" />
                    {!isPasswordFormVisible && (
                        <div id="password_desc" className="section-desc text-muted m-t show">
                            Change password used to sign in.
                        </div>
                    )}
                </div>
            </div>

            <div className="padding-top-large"></div>

            {isPasswordFormVisible && (
                <div id="password_form">
                    <div className="section-desc text-muted m-t">
                        Password should be longer than 8 letters, must contain a number, a capital
                        letter, a lowercase letter, and a special character from ~!@#$%^&*(),.+;:?/.
                    </div>
                    <div className="padding-top-large"></div>
                    <FoundationsForm
                        id="password_form_el"
                        submitFunction={handleSubmitPassword(handlePasswordSettings)}
                    >
                        <div className="row">
                            <div className="col-sm-12">
                                <FoundationsInput
                                    classes="form-group row"
                                    id="text_Box_Old_Password"
                                    type="password"
                                    name="oldPassword"
                                    value={PasswordData.oldPassword}
                                    maxLength={24}
                                    labelText="Old Password:"
                                    errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                    labelClasses="col-sm-2 col-form-label"
                                    containerClasses="col-sm-4"
                                    onInput={handlePasswordInputChange}
                                    registerFunction={registerPassword}
                                    registerRules={FormValidation.loginPassword}
                                    error={oldPasswordError || passwordErrors.oldPassword?.message}
                                    registerName="oldPassword"
                                />
                                <div style={{ height: '17px' }}>
                                    <label
                                        htmlFor="oldPassword"
                                        className="error field-validation-error"
                                    ></label>
                                </div>
                            </div>

                            <div className="col-sm-12">
                                <FoundationsInput
                                    classes="form-group row"
                                    id="text_Box_New_Password"
                                    type="password"
                                    name="newPassword"
                                    value={PasswordData.newPassword}
                                    maxLength={24}
                                    labelText="New Password:"
                                    errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                    labelClasses="col-sm-2 col-form-label"
                                    containerClasses="col-sm-4"
                                    onInput={handlePasswordInputChange}
                                    registerFunction={registerPassword}
                                    registerRules={{
                                        ...FormValidation.registerPassword,
                                        validate: (val: string) => passwordValidate(val, GeneralData.FirstName, GeneralData.LastName),
                                    }}
                                    error={newPasswordError || passwordErrors.newPassword?.message}
                                    registerName="newPassword"
                                />
                                <div style={{ height: '17px' }}>
                                    <label
                                        htmlFor="newPassword"
                                        className="error field-validation-error"
                                    ></label>
                                </div>
                            </div>

                            <div className="col-sm-12">
                                <FoundationsInput
                                    classes="form-group row"
                                    id="text_Box_Reenter_Password"
                                    type="password"
                                    name="ReenterPassword"
                                    value={PasswordData.ReenterPassword}
                                    labelText="Confirm New Password:"
                                    maxLength={24}
                                    errorClasses="col-12 offset-lg-3 col-lg-9 text-left"
                                    labelClasses="col-sm-2 col-form-label"
                                    containerClasses="col-sm-4"
                                    onInput={handlePasswordInputChange}
                                    registerFunction={registerPassword}
                                    registerRules={{
                                        ...FormValidation.confirmPasswordUserSettings,
                                        validate: passwordsMatch,
                                    }}
                                    error={passwordErrors.ReenterPassword?.message}
                                    registerName="ReenterPassword"
                                />
                                <div style={{ height: '17px' }}>
                                    <label
                                        htmlFor="ReenterPassword"
                                        className="error field-validation-error"
                                    ></label>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 text-left d-flex justify-content-center">
                                <FoundationsButton
                                    type="submit"
                                    classes="p-l-0"
                                    id="buttonPasswordSaveChanges"
                                    buttonClasses="app-button"
                                    disabled={false}
                                    isLoading={passwordLoading}
                                    customStyle={{ marginLeft: '175px' }}
                                >
                                    Save Password
                                </FoundationsButton>
                                <FoundationsButton
                                    classes="col-4"
                                    id="buttonPasswordCancelChanges"
                                    buttonClasses="app-button negative"
                                    disabled={false}
                                    onClick={resetPasswordForm}
                                >
                                    Cancel
                                </FoundationsButton>
                            </div>
                        </div>
                    </FoundationsForm>
                </div>
            )}

            <div className="row">
                <div className="col-6">
                    <h3>Notifications</h3>
                </div>
                <div className="col-6 text-right negative-margin-y">
                    <a
                        id="notification_link"
                        className="click_toggle_form_visibility"
                        style={{ cursor: 'pointer' }}
                        onClick={showNotificationWrapper}
                    >
                        {isNotificationFormVisible ? 'Hide' : 'Change'}
                    </a>
                </div>
                <div className="col-12">
                    <hr className="m-t" />
                    <div id="notification_desc" className="section-desc text-muted m-t show">
                        Change notification options.
                    </div>
                </div>
            </div>
            <div className="padding-top-large"></div>
            {isNotificationFormVisible && (
                <div id="notification_wrapper">
                    <div id="notification_form" style={{ marginRight: '3rem' }}>
                        <div className="padding-bottom-large">
                            Email me the following every day:
                        </div>
                        <form id="notification_form_el" style={{ marginLeft: '2rem' }}>
                            <div className="form-group row">
                                <div className="col-sm-12">
                                    <FoundationsCheckBox
                                        classes="row"
                                        id="email_summary_report_checkbox"
                                        name="emailSummaryReport"
                                        checked={NotificationData.emailSummaryReport}
                                        value="false"
                                        labelText="Included Summary Reports"
                                        labelClasses="px-4"
                                        containerClasses="col-12 ml-0 ml-md-5 pl-0 pl-md-5"
                                        inputClasses="checkbox-height"
                                        onChange={handleNotificationChange}
                                    />
                                </div>
                                <div className="col-sm-12">
                                    <FoundationsCheckBox
                                        classes="row"
                                        id="email_notes_checkbox"
                                        name="emailNewNotes"
                                        checked={NotificationData.emailNewNotes}
                                        value="false"
                                        labelText="New Notes"
                                        labelClasses="px-4"
                                        containerClasses="col-12 ml-0 ml-md-5 pl-0 pl-md-5"
                                        inputClasses="checkbox-height"
                                        onChange={handleNotificationChange}
                                    />
                                </div>
                                <div className="col-sm-12">
                                    <FoundationsCheckBox
                                        classes="row"
                                        id="email_dict_checkbox"
                                        name="emailNewDictValues"
                                        checked={NotificationData.emailNewDictValues}
                                        value="false"
                                        labelText="New Dictionary"
                                        labelClasses="px-4"
                                        containerClasses="col-12 ml-0 ml-md-5 pl-0 pl-md-5"
                                        inputClasses="checkbox-height"
                                        onChange={handleNotificationChange}
                                    />
                                </div>
                                <div className="col-sm-12">
                                    <FoundationsCheckBox
                                        classes="row"
                                        id="email_listener_checkbox"
                                        name="emailListenerActivity"
                                        checked={NotificationData.emailListenerActivity}
                                        value="false"
                                        labelText="Data Sources Activity"
                                        labelClasses="px-4"
                                        containerClasses="col-12 ml-0 ml-md-5 pl-0 pl-md-5"
                                        inputClasses="checkbox-height"
                                        onChange={handleNotificationChange}
                                    />
                                </div>
                            </div>
                        </form>
                        <div className="row">
                            <div className="col-12 text-left d-flex justify-content-center">
                                <FoundationsButton
                                    classes="p-l-0"
                                    id="buttonNotificationSaveChanges"
                                    buttonClasses="app-button"
                                    onClick={handleNotificationSettings}
                                    disabled={false}
                                    isLoading={notificationLoading}
                                    customStyle={{ marginLeft: '175px' }}
                                >
                                    Save Changes
                                </FoundationsButton>
                                <FoundationsButton
                                    classes="col-4"
                                    id="buttonNotificationCancelChanges"
                                    buttonClasses="app-button negative"
                                    disabled={false}
                                    isLoading={false}
                                    onClick={resetNotificationForm}
                                >
                                    Cancel
                                </FoundationsButton>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="row">
                <div className="col-6">
                    <h3>Attributes</h3>
                </div>
                <div className="col-6 text-right">
                    <a
                        id="attributes_link"
                        className="click_toggle_form_visibility_show"
                        style={{ cursor: 'pointer' }}
                        onClick={showAttributesWrapper}
                    >
                        {isAttributesFormVisible ? 'Hide' : 'Show'}
                    </a>
                </div>
                <div className="col-12">
                    <hr className="m-t"></hr>
                    <div id="attributes_desc" className="section-desc text-muted m-t show">
                        View your personalization attributes, staff name mappings, locations and
                        more..
                        <div id="attributes_statusMessage"></div>
                    </div>
                    <div className="padding-top-large"></div>
                    {isAttributesFormVisible && (
                        <div id="Attributes_Form">
                            <div className="padding-top-large"></div>
                            <div>
                                {UserAttributes.map((item: any, index: number) => (
                                    <>
                                        <div className="row" key={index}>
                                            <div className="col-sm-4 text-muted">
                                                {item.FieldName}:
                                            </div>
                                            <div className="col-sm-8">
                                                {item.displaytextandkeyset.map(
                                                    (textItem: any, textIndex: number) => (
                                                        <div className="col-sm-4" key={textIndex}>
                                                            {textItem.DisplayText == '- select a location -' ? ' ' : textItem.DisplayText}
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                        <br />
                                    </>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {isProxyModeAllowed && (
                <div className="row">
                    <div className="col-6">
                        <h3>Proxy User</h3>
                    </div>
                    <div className="col-6 text-right">
                        <a style={{ cursor: 'pointer' }} id="proxy_link" className='click_toggle_form_visibility_show' onClick={showUsersDialog}>
                            Show
                        </a>
                    </div>
                    <div className="col-12">
                        <hr className="m-t"></hr>
                        <div id="proxy_desc" className="section-desc text-muted m-t">
                            Log in as another user
                        </div>
                    </div>
                </div>
            )}
            </Skeleton>
            <Dialog 
                isOpen={proxyDialog} 
                title='Find Users' 
                minHeight={482} 
                width={520.5} 
                height={'auto'} 
                onClose={() => setproxyDialog(false)} 
                buttons={[
                    { 
                        label: 'Cancel', 
                        onClick: () => setproxyDialog(!proxyDialog), 
                        className: 'ui-button ui-corner-all ui-widget app-button negative' 
                    },
                    { 
                        label: 'Proxy', 
                        onClick: handleProxyClick, 
                        className: 'ui-button ui-corner-all ui-widget app-button' 
                    }
                ]}
            >
                <div id='user_search_dialog_wrapper'>
                    <div className="searchlist-popup-header">
                        <input
                            type="text"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            onKeyDown={handleKeydown}
                            placeholder="enter a few letters and click find"
                            maxLength={100}
                            size={40}
                        />
                        <span>&nbsp;&nbsp;</span>
                        <button className='ui-button app-button' onClick={findUser} disabled={getUserLoading}>
                            <span
                                className="ui-button-text">Find</span></button>
                    </div>
                    <span className="clear-both"></span>
                    <span>&nbsp;&nbsp;</span>
                    <ol id="user_search_list" className='dashboard-list'>
                        {userList.length > 0 ? (
                            userList.map(user => (
                                <li
                                    key={user.KeyValue}
                                    id={`user_${user.KeyValue}`}
                                    className={user.KeyValue === selectedUserId ? 'ui-selected' : 'ui-not-selected'}
                                    onClick={() => handleSelectUser(user.KeyValue)}
                                >
                                    <div className="float-left fieldradio">
                                        <input
                                            type="radio"
                                            id={`user_radio_${user.KeyValue}`}
                                            name="user_radio"
                                            value={user.KeyValue}
                                            checked={user.KeyValue === selectedUserId}
                                            onChange={() => handleSelectUser(user.KeyValue)} // Required to make the radio button controlled
                                        />
                                    </div>
                                    <div className="float-left fieldcontent">
                                        <div
                                            className="dashboard-list-header"
                                            dangerouslySetInnerHTML={{ __html: user.DisplayText }}
                                        />
                                        <div className="dashboard-list-sub-header">{user.Description}</div>
                                    </div>
                                    <div className="clear-both"></div>
                                </li>
                            ))
                        ) : (
                            findClicked && (
                                <li className="info">Sorry, no matches found. Try a different search.</li>
                            )
                        )}
                    </ol>
                    {Error && (
                        <div
                            id="valmsg_user_search_list"
                            className={`error-message ${errorHighlight ? 'error-message-highlight' : ''}`}
                        >
                            {Error}
                        </div>
                    )}                   
                </div>
            </Dialog>
        </>
    )
}

export default AccountSettings
